import { useEffect, useRef, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import { api, pad2, rupiah } from "@/lib/api";

let audioCtx = null;

const chime = () => {
  if (!audioCtx) return;
  const t = audioCtx.currentTime;
  [880, 1175, 1568].forEach((freq, i) => {
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, t + i * 0.18);
    gain.gain.exponentialRampToValueAtTime(0.35, t + i * 0.18 + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + i * 0.18 + 0.5);
    osc.connect(gain).connect(audioCtx.destination);
    osc.start(t + i * 0.18);
    osc.stop(t + i * 0.18 + 0.55);
  });
};

export const OrderAlerts = () => {
  const [enabled, setEnabled] = useState(false);
  const seen = useRef(null);

  const toggle = () => {
    if (!enabled) {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      audioCtx.resume();
      chime();
    }
    setEnabled(!enabled);
  };

  useEffect(() => {
    const check = async () => {
      const { data } = await api.get("/admin/orders", { params: { status: "aktif" } }).catch(() => ({ data: null }));
      if (!data) return;
      const now = Object.fromEntries(data.map((o) => [o.id, o.status]));
      if (seen.current) {
        const fresh = data.filter((o) => !(o.id in seen.current));
        const paid = data.filter((o) => o.status === "menunggu_konfirmasi" && seen.current[o.id] && seen.current[o.id] !== "menunggu_konfirmasi");
        fresh.forEach((o) => toast.info(`Pesanan baru ${o.code} · ${rupiah(o.total)} · Lantai ${o.floor} Meja ${pad2(o.table)}`, { duration: 8000 }));
        paid.forEach((o) => toast.warning(`Pembayaran masuk ${o.code} · cek nominal ${rupiah(o.total)}`, { duration: 8000 }));
        if ((fresh.length || paid.length) && enabled) chime();
      }
      seen.current = now;
    };
    check();
    const t = setInterval(check, 7000);
    return () => clearInterval(t);
  }, [enabled]);

  return (
    <button onClick={toggle} data-testid="staff-sound-toggle"
      className={`flex items-center gap-1.5 px-3 py-2 rounded-lg border text-sm transition-colors ${enabled ? "bg-forest text-paper border-forest" : "border-amber-300 bg-amber-50 text-amber-900"}`}>
      {enabled ? <Bell className="w-4 h-4" /> : <BellOff className="w-4 h-4" />}
      <span className="hidden sm:inline">{enabled ? "Suara aktif" : "Aktifkan suara"}</span>
    </button>
  );
};
